const log: typeof console.log = (...args) => {
  // eslint-disable-next-line no-console
  console.log(...args);
};

const warn: typeof console.warn = (...args) => {
  // eslint-disable-next-line no-console
  console.warn(...args);
};

const error: typeof console.error = (...args) => {
  extractAndReportError(args);
  // eslint-disable-next-line no-console
  console.error(...args);
};

export const logger = {
  log,
  warn,
  error,
};

const extractAndReportError = (args: unknown[]): void => {
  if (!reportFirstError(args)) {
    try {
      // try stringifying
      reportError(new Error(JSON.stringify(args)));
    } catch {
      // try first element
      if (typeof args[0] === "string") {
        reportError(new Error(args[0]));
      } else {
        try {
          reportError(new Error(JSON.stringify(args[0])));
        } catch {
          reportError(new Error("Unknown error"));
        }
      }
    }
  }
};

const reportFirstError = (args: unknown[]): boolean =>
  args.some((arg) => arg instanceof Error && reportError(arg));

export const reportError = (error: Error): void => {
  try {
    window.cwr("recordError", error);
  } catch {
    // eslint-disable-next-line no-console
    console.warn("Could not log error to AWS RUM");
  }
};
